import './styles.css';

export default function App() {
  return (
    <main className="shell">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <h1>Xinfeng Plastics</h1>
          <p className="tagline">Premium Acrylic & PVC Foam Sheets for Global Markets</p>
          <div className="cta-buttons">
            <a href="#products" className="btn-primary">Our Products</a>
            <a href="#contact" className="btn-secondary">Contact Us</a>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about" id="about">
        <div className="container">
          <h2>About Xinfeng Plastics</h2>
          <p>
            With 15 years of expertise in export-grade plastic sheets, Xinfeng Plastics embodies the philosophy 
            "Xin is faith, Feng is peak." We specialize in manufacturing high-quality acrylic and PVC foam sheets 
            with rigorous quality control standards. Our professional technical capabilities and reliable delivery 
            help our global clients' products stand out in the market.
          </p>
          <p>
            Our products are exported to over 70 countries and regions, making us a trusted long-term partner 
            for numerous international customers.
          </p>
        </div>
      </section>

      {/* Products Section */}
      <section className="products" id="products">
        <div className="container">
          <h2>Our Products</h2>
          <div className="product-categories">
            <div className="category">
              <h3>Acrylic Sheets</h3>
              <ul>
                <li>Transparent</li>
                <li>Colored</li>
                <li>Thick Plates</li>
              </ul>
            </div>
            <div className="category">
              <h3>PVC Foam Sheets</h3>
              <ul>
                <li>Free Foaming</li>
                <li>Crust</li>
                <li>Supply</li>
                <li>Laminated</li>
              </ul>
            </div>
            <div className="category">
              <h3>Other Sheets</h3>
              <ul>
                <li>PS</li>
                <li>PETG</li>
                <li>ABS</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services">
        <div className="container">
          <h2>Core Services</h2>
          <p>
            We focus on manufacturing and exporting PVC and acrylic materials, providing highly customized 
            solutions that fully meet our clients' diverse requirements in product performance, design, 
            and application scenarios.
          </p>
          <p>
            Our business covers high-end advertising signage, furniture manufacturing, basic construction, 
            and commercial spaces globally. We serve international brand owners, wholesalers, engineering 
            contractors, and industrial clients.
          </p>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact" id="contact">
        <div className="container">
          <h2>Contact Us</h2>
          <div className="contact-info">
            <p><strong>Phone:</strong> +86 15965315578</p>
            <p><strong>Email:</strong> info@xinfengplastics.com</p>
            <p><strong>Address:</strong> Jinan, Shandong, China</p>
          </div>
          <div className="contact-form">
            <form>
              <div className="form-row">
                <input type="text" placeholder="Your Name" required />
                <input type="email" placeholder="Your Email" required />
              </div>
              <div className="form-row">
                <input type="text" placeholder="Company Name" />
                <input type="tel" placeholder="Phone Number" />
              </div>
              <textarea placeholder="Your Message" rows="4" required></textarea>
              <button type="submit" className="btn-primary">Send Message</button>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>&copy; 2026 Xinfeng Plastics. All rights reserved.</p>
        </div>
      </footer>
    </main>
  );
}